<template>
  <div>
    <div class="container-fluid">
      <v-row align="center" no-gutters>
        <v-col cols="12">
          <v-img
            class="bg-size"
            :src="`https://www.risoul.com.mx/hs-fs/hubfs/banner/bg-quienes.jpg?width=1280&name=bg-quienes.jpg`"
            aspect-ratio="1"
          >
            <span al>Acerca de Nosotros</span>
          </v-img>
        </v-col>
      </v-row>

      <v-row align="center" no-gutters>
        <v-col
          class="d-flex justify-center align-center"
          style="background-color: #fa6b17"
          cols="12"
        >
          <p class="texto">
            Con más de 45 años de experiencia innovando en soluciones para la
            industria eléctrica en el mercado mexicano, nuestra filosofía es la
            de ofrecer un valor agregado a nuestros clientes no sólo con
            productos y soluciones sino con nuestra gente, que es lo que nos
            distingue en el mercado industrial.
          </p>
        </v-col>
      </v-row>

      <!-- Associations and Certifications Start-->
      <div id="about" class="section-padding">
        <v-container>
          <div class="row">
            <div class="col-lg-3 col-md-6 col-xs-12">
              <div class="about block text-center">
                <img src="./../../assets/homePage/iso.png" alt="" />
                <h5>Certificación ISO Diciembre 2001</h5>
                <p>
                  ISO-9001:2015 <br />
                  (Como distribuidores de materiales, equipo eléctrico y
                  automatización, Monterrey Sucursal Matriz)
                </p>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-xs-12">
              <div class="about block text-center">
                <img src="./../../assets/homePage/logo-traced.jpg" alt="" />
                <h5>
                  <a
                    href="https://tpms.tcompliance.com/IntermediaryDirectory"
                    target="_blank"
                  >
                    TCompliance
                  </a>
                </h5>
                <p>Miembros desde agosto 2010</p>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-xs-12">
              <div class="about block text-center">
                <img src="./../../assets/homePage/naed-logo.png" alt="" />
                <h5>Miembro de NAED desde 2003</h5>
                <p>
                  (Asociación Internacional de distribuidores de equipo
                  eléctrico)
                </p>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-xs-12">
              <div class="about block text-center">
                <img src="./../../assets/homePage/affilieted-dist.png" alt="" />
                <h5>Affiliated Distributors</h5>
                <p>Miembro de Affiliated Distributors desde 2014</p>
              </div>
            </div>
          </div>
        </v-container>
      </div>
      <!-- Associations and Certifications End-->
    </div>
  </div>
</template>

<script>
export default {
  name: "home_page",

  components: {},

  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
          title: "Imagen de Prueba",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
          title: "Imagen de Prueba",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
          title: "Imagen de Prueba",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
          title: "Imagen de Prueba",
        },
      ],
    };
  },

  methods: {},

  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },

  watch: {},

  created() {},

  mounted() {},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Rubik:400,700|Montserrat:700");

/* Typography */
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #444;
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  letter-spacing: 0px;
  margin-top: 0;
}

p {
  font-family: "Rubik", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #444;
  letter-spacing: 0px;
  margin-bottom: 10px;
}

span {
  font-family: "Rubik", sans-serif;
  font-size: 55px;
  color: white;
  display: table;
  margin-top: 135px !important;
  margin: 0 auto;
  text-decoration: underline;
}

.texto {
  font-size: 20px;
  font-family: "Rubik", sans-serif;
  color: white;
  margin: 70px;
  text-align: center;
}

.bg-size {
  height: 360px;
}

.v-image__image {
  background-size: 100% 100%;
}

#about {
  background: #f6f6f6;
}

.section-padding {
  padding: 60px 0 !important;
}

.about h5 {
  font-size: 18px;
}

.about h5 a {
  color: #444;
  text-decoration: none;
}

.about h5 a:hover {
  color: #fa6b17;
}

/* only small tablets */
@media (min-width: 768px) and (max-width: 991px) {
}

/* mobile or only mobile */
@media (max-width: 767px) {
  .section-padding {
    padding: 50px 0;
  }
}
</style>
